var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ColumnBaseComponent } from '../../../../../items/columns/base/columnbase.component';
import { ColumnService } from '../../../../../items/columns/column/column.service';
import { ColumnBaseService } from '../../../../../items/columns/base/columnbase.service';
var KtsPickadateComponent = /** @class */ (function (_super) {
    __extends(KtsPickadateComponent, _super);
    function KtsPickadateComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.initValue1 = '2019/10/10 09:00';
        return _this;
    }
    KtsPickadateComponent.prototype.ngOnChanges = function (changes) {
    };
    KtsPickadateComponent.prototype.ngOnInit = function () {
        // super.ngOnInit();
    };
    KtsPickadateComponent.prototype.ngAfterViewInit = function () {
        var dateOptions = {
            format: 'yyyy/mm/dd',
            monthsFull: [
                '1月',
                '2月',
                '3月',
                '4月',
                '5月',
                '6月',
                '7月',
                '8月',
                '9月',
                '10月',
                '11月',
                '12月',
            ],
            monthsShort: [
                '1月',
                '2月',
                '3月',
                '4月',
                '5月',
                '6月',
                '7月',
                '8月',
                '9月',
                '10月',
                '11月',
                '12月',
            ],
            weekdaysFull: [
                '日曜日',
                '月曜日',
                '火曜日',
                '水曜日',
                '木曜日',
                '金曜日',
                '土曜日',
            ],
            weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
            // showMonthsShort: undefined,
            // showWeekdaysFull: undefined,
            today: '今日',
            clear: 'クリア',
            close: '閉じる',
            labelMonthNext: '来月',
            labelMonthPrev: '前月',
            labelMonthSelect: '月選択',
            labelYearSelect: '年選択',
            // selectYears: true,
            // selectMonths: true,
            onClose: function () {
                // console.log('onClose');
                this.close(true);
            },
        };
        var timeOptions = {
            format: 'HH:i',
            clear: 'クリア',
            interval: 10,
            onClose: function () {
                // console.log('onClose');
                this.close(true);
            },
        };
        var self = this;
        $('#pickadateDateTest1').pickadate(Object.assign({}, dateOptions, {
            onStart: function () {
                this.set('select', new Date(self.initValue1));
                self.date1 = this.get('select');
            },
            onOpen: function () {
                if (self.date2) {
                    this.set('max', [self.date2['year'], self.date2['month'], self.date2['date']]);
                }
            },
            onSet: function (context) {
                self.date1 = this.get('select');
                // console.log('onSet:', self.date1);
            }
        }));
        $('#pickadateTimeTest1').pickatime(Object.assign({}, timeOptions, {
            onStart: function () {
                this.set('select', new Date(self.initValue1));
                self.date1 = this.get('select');
            },
            onOpen: function () {
                // if (self.time2) {
                //     this.set('max', [self.time2['hour'], self.time2['mins']]);
                // }
            },
            onSet: function (context) {
                self.time1 = this.get('select');
                // console.log('onSet:', self.time1);
            }
        }));
        $('#pickadateDateTest2').pickadate(Object.assign({}, dateOptions, {
            onStart: function () {
                self.date2 = this.get('select');
            },
            onOpen: function () {
                if (self.date1) {
                    this.set('min', [self.date1['year'], self.date1['month'], self.date1['date']]);
                }
            },
            onSet: function (context) {
                self.date2 = this.get('select');
                // console.log('onSet:', self.date2);
            }
        }));
        $('#pickadateTimeTest2').pickatime(Object.assign({}, timeOptions, {
            onStart: function () {
                self.date2 = this.get('select');
            },
            onOpen: function () {
                // if (self.time1) {
                //     this.set('min', [self.time1['hour'], self.time1['mins']]);
                // }
            },
            onSet: function (context) {
                self.time2 = this.get('select');
                // console.log('onSet:', self.time2);
            }
        }));
    };
    KtsPickadateComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-column-pickadate',
                    template: "\n        <p class=\"sectionHeading\">pickadate</p>\n        <div class=\"-ml-3\">\n            <dl class=\"form\">\n                <dt class=\"form_dt\"><label class=\"formLabelText\">\u65E5\u6642(Form~To)</label></dt>\n                <dd class=\"form_dd\">\n                    <ul>\n                        <li class=\"form_li form_li-w150\"><input type=\"text\" class=\"formInputText\" id=\"pickadateDateTest1\"></li>\n                        <li class=\"form_li form_li-w100\"><input type=\"text\" class=\"formInputText\" id=\"pickadateTimeTest1\"></li>\n                        <li class=\"form_li\">~</li>\n                        <li class=\"form_li form_li-w150\"><input type=\"text\" class=\"formInputText\" id=\"pickadateDateTest2\"></li>\n                        <li class=\"form_li form_li-w100\"><input type=\"text\" class=\"formInputText\" id=\"pickadateTimeTest2\"></li>\n                    </ul>\n                </dd>\n            </dl>\n        </div>\n    "
                }] }
    ];
    /** @nocollapse */
    KtsPickadateComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    return KtsPickadateComponent;
}(ColumnBaseComponent));
export { KtsPickadateComponent };
//# sourceMappingURL=pickadate.component.js.map